import { useEffect, useRef } from 'react'
import { useLocation, useScreenId, useIsScreenLoading } from '@muse-web/router'

import type { ScreenId } from '@core/router'

import { resolveScreen } from '../helpers/resolveScreen'
import { setCurrentScreen } from '../helpers/currentScreen'
import { flushPendingPerfMetrics } from '../helpers/pendingPerfMetrics'
import { trackNavigation } from '../helpers/renderType'
import { trackScreenView } from '../helpers/trackScreenView'

/** Sets the active screen and fires `page_view` on soft navigation — see docs/analytics.md. */
export const useScreenViewTracking = () => {
    const screenId = useScreenId<ScreenId>()
    const { pathname } = useLocation()
    const isScreenLoading = useIsScreenLoading()
    const sentPathname = useRef(pathname)

    if (!isScreenLoading) {
        setCurrentScreen(resolveScreen(screenId, pathname))
    }

    useEffect(() => {
        trackNavigation(pathname)

        if (isScreenLoading) {
            return
        }

        flushPendingPerfMetrics()

        if (sentPathname.current === pathname) {
            return
        }

        sentPathname.current = pathname
        trackScreenView(screenId)
    }, [pathname, screenId, isScreenLoading])
}
